//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Display.js";
import "../no/Object.js";
let d=[[],[],[]];
SPLM.Display.DynamicSectionTypes = class extends SPLM.Object{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Display.DynamicSectionTypes";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Display.DynamicSectionTypes.ActivePlane = Object.freeze({
    "Primary" : "Primary", "Secondary" : "Secondary"});

SPLM.Display.DynamicSectionTypes.Axis = Object.freeze({
    "None" : "None", "X" : "X", "Y" : "Y", "Z" : "Z"});

SPLM.Display.DynamicSectionTypes.CapColorOption = Object.freeze({
    "Body" : "Body", "Any" : "Any"});

SPLM.Display.DynamicSectionTypes.Clip = Object.freeze({
    "Section" : "Section", "Slice" : "Slice"});

SPLM.Display.DynamicSectionTypes.CoordinateSystem = Object.freeze({
    "Absolute" : "Absolute", "Wcs" : "Wcs"});

SPLM.Display.DynamicSectionTypes.CurveColorOption = Object.freeze({
    "Body" : "Body", "Any" : "Any"});

SPLM.Display.DynamicSectionTypes.Type = Object.freeze({
    "OnePlane" : "OnePlane", "TwoParallelPlanes" : "TwoParallelPlanes", "Box" : "Box"});

export default SPLM;